import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExminderViewClientStore from '../../../../clientStore/ExminderViewClientStore';
import ConfirmActionModal from '../Modals/ConfirmActionModal';
import * as SC from './styles';

interface EmptyPackagesStateProps {
  isExminder: boolean;
  isBusinessMode: boolean;
  isOnboardingSkipped: boolean;
  onCreateExperienceClick: CallbackFunction;
  onCreateAuctionClick: CallbackFunction;
  onTurnOnNotifications: CallbackFunction;
  onBuildProfile: CallbackFunction;
}

export default function EmptyPackagesState({
  isExminder,
  isBusinessMode,
  isOnboardingSkipped,
  onCreateAuctionClick,
  onCreateExperienceClick,
  onTurnOnNotifications,
  onBuildProfile,
}: EmptyPackagesStateProps) {
  const [isBuildProfileModalOpen, setIsBuildProfileModalOpen] = useState(false);

  const { t } = useTranslation();
  const businessEmptyStateText = (
    <SC.TextContainer>
      <SC.Text> {t(`experienceFeed.emptyState.title`)}</SC.Text>
      <SC.Text>
        {t(`experienceFeed.emptyState.subtitle`)}
        <br />
        {t(`experienceFeed.emptyState.subtitleBusiness`)}
      </SC.Text>
    </SC.TextContainer>
  );

  const emptyStateText = (
    <SC.TextContainer>
      <SC.Text> {t(`experienceFeed.emptyState.title`)}</SC.Text>
      <SC.Text>
        {t(`experienceFeed.emptyState.subtitle`)}
        <br />
        {isExminder && ExminderViewClientStore.getExminderView()
          ? t(`experienceFeed.emptyState.subtitleExminder`)
          : t(`experienceFeed.emptyState.subtitleExplorer`)}
      </SC.Text>
    </SC.TextContainer>
  );
  return (
    <SC.Container>
      {isBusinessMode ? businessEmptyStateText : emptyStateText}
      {
        isExminder &&
        !isBusinessMode &&
        ExminderViewClientStore.getExminderView() ? (
          // <ButtonsCreateExperienceAuction
          //   onCreateAuctionClick={onCreateAuctionClick}
          //   onCreateExperienceClick={onCreateExperienceClick}
          // />
          <SC.AddButton
            onClick={() =>
              isOnboardingSkipped
                ? setIsBuildProfileModalOpen(true)
                : onCreateExperienceClick()
            }
          >
            <SC.WhiteText>
              {t(`addExperience.createExperienceBtn`)}
            </SC.WhiteText>
          </SC.AddButton>
        ) : null
        // (
        // <SC.LinkText onClick={onTurnOnNotifications}>
        //   {t(`experienceFeed.emptyState.buttonTurnOnNotification`)}
        // </SC.LinkText>
        // )
      }
      <ConfirmActionModal
        isOpen={isBuildProfileModalOpen}
        onClose={() => {
          setIsBuildProfileModalOpen(false);
        }}
        onConfirm={onBuildProfile}
        title={t(`createProfile.onBoardingSkippedModal.title`)}
        description={[t(`createProfile.onBoardingSkippedModal.subtitle`)]}
        cancelText={t(`general.cancel`)}
        confirmationText={t(
          `createProfile.onBoardingSkippedModal.createProfile`
        )}
      />
    </SC.Container>
  );
}
